export default "__VITE_ASSET__DI16f4CY__"